const actions = {
    GET_VEHICLE_CONFIGURATION: `vehicleConfiguration/GET_VEHICLE_CONFIGURATION`,
    SET_VEHICLE_CONFIGURATION: `vehicleConfiguration/SET_VEHICLE_CONFIGURATION`
};

export default actions;
